var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.currentTab === _vm.tab.tab ? 'selected' : '', 'tab'],on:{"click":function($event){$event.stopPropagation();return _vm.changeTabs(_vm.currentTab, _vm.tab)}}},[_vm._v(" "+_vm._s(_vm.tab.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }